import { SuperbetRouteConfig } from '@superbet-group/web.types';

import { Link } from '@app/router/constants/Link';
import { RouteName } from '@app/router/constants/RouteName';
import { Title } from '@app/router/constants/Title';
import { defaultLayout } from '@app/router/utils';

import PageNotFound from './PageNotFound.vue';
import { Route } from 'vue-router';

export const notFoundRoute: SuperbetRouteConfig = {
    path: Link.App.NotFound,
    name: RouteName.App.NotFound,
    components: {
        ...defaultLayout,
        content: PageNotFound,
    },
    meta: {
        title: Title.App.NotFound,
        disableIndexing: (_route: Route) => true,
    },
};

export const catchAllRoute: SuperbetRouteConfig = {
    path: Link.App.CatchAll,
    name: RouteName.App.CatchAll,
    components: {
        ...defaultLayout,
        content: PageNotFound,
    },
    meta: {
        title: Title.App.NotFound,
        disableIndexing: (_route: Route) => true,
    },
};
